import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const BrandingCtx = createContext({ app_name: "BizAssist Online", logo_data_url: "", theme_preset: "default", refresh: () => {} });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({ app_name: "BizAssist Online", logo_data_url: "", theme_preset: "default" });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setBranding({
        app_name: data.app_name || "BizAssist Online",
        logo_data_url: data.logo_data_url || "",
        theme_preset: data.theme_preset || "default",
      });
    } catch (_e) { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Apply theme + document title + favicon side-effects when branding changes
  useEffect(() => {
    const t = branding.theme_preset === "default" ? "" : branding.theme_preset;
    if (t) document.documentElement.setAttribute("data-theme", t);
    else document.documentElement.removeAttribute("data-theme");

    if (branding.app_name) document.title = branding.app_name;

    if (branding.logo_data_url) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = branding.logo_data_url;
    }
  }, [branding]);

  return <BrandingCtx.Provider value={{ ...branding, refresh }}>{children}</BrandingCtx.Provider>;
}

export const useBranding = () => useContext(BrandingCtx);
